import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {DataService} from '../../services/data.service';
import {RatefileTspExtService} from '../../services/ratefile-tsp-ext/ratefile-tsp-ext.service';
import {RatesTspExt} from './rates-tsp-ext';
import {ControlKeys} from '../ratefile-open/control-keys';
import {Carrier} from '../../shared/common-components/common-structure';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';

/* test comments*/
@Component({
    selector: 'app-ratefile-tsp-ext',
    templateUrl: './ratefile-tsp-ext.component.html',
    styleUrls: ['./ratefile-tsp-ext.component.css'],
    standalone: false
})
export class RatefileTspExtComponent implements OnInit {
    ratePeriodDetails: ControlKeys[];
    ratePeriodRec: ControlKeys[];
    typeaheadlist: string[];
    businessType: any;
    carrierList: Carrier[];
    scacCodeList: string[] = [];
    disabled = true;
    minLengthToSearch: Number;
    maxCharLength: Number;
    rateFileTspExtForm: UntypedFormGroup;
    selectedCarrier: any;
    carrierRateRec: any;
    closeMinDate: any;
    ratesTspExt: RatesTspExt;
    currentRatePeriod: any;
    buttonDisable = true;
    updateSuccessful = false;
    updateFailure = false;
    datePickerConfig: Partial<BsDatepickerConfig>;

    constructor(private rateFileTspExtService: RatefileTspExtService,
                private fb: UntypedFormBuilder,
                private alertService: AlertService,
                private tmssLoader: LoadingService,
                private dataService: DataService,
                private router: Router
    ) {
        this.createForm();
        this.rateFileTspExtForm.controls['rateType'].setValue(null);
        this.rateFileTspExtForm.controls['ratePeriod'].setValue(null);
        this.rateFileTspExtForm.controls['carrierKeyword'].setValue('');
        this.closeMinDate = new Date();
        this.closeMinDate.setDate(this.closeMinDate.getDate());
        this.datePickerConfig = Object.assign({},
            {
                containerClass: 'theme-dark-blue',
                showWeekNumbers: false,
                minDate: this.closeMinDate,
                dateInputFormat: 'MM/DD/YYYY'
            });
    }

    ngOnInit() {
    }

    createForm() {
        this.rateFileTspExtForm = this.fb.group({
            rateType: new UntypedFormControl('', [Validators.required]),
            ratePeriod: new UntypedFormControl('', [Validators.required]),
            carrierKeyword: new UntypedFormControl(''),
            carrierSelected: new UntypedFormControl(''),
            rateEffeciveDate: new UntypedFormControl(''),
            rateExpiryDate: new UntypedFormControl(''),
            rateReleaseDate: new UntypedFormControl(''),
            tspExpiryDate: new UntypedFormControl('', [Validators.required]),
            carrierSelectedForTable: new UntypedFormControl(''),
            rateEffeciveDateForTable: new UntypedFormControl(''),
            rateExpiryDateForTable: new UntypedFormControl('')
        });
    }
    /*
    * When user changes the rate type, this populates all the rate period and the Typehead List
    */

    changeRateType(event: any) {
        console.log(this.rateFileTspExtForm.controls['rateType'].value);
        this.tmssLoader.show();
        this.rateFileTspExtService.getRateFilePeriod(this.rateFileTspExtForm.controls['rateType'].value)
            .subscribe ( rateFileRecords => {
                console.log(rateFileRecords);
                this.ratePeriodDetails = rateFileRecords;
                (rateFileRecords as ControlKeys[]);
                rateFileRecords.forEach( ratePeriodRec => {
                    rateFileRecords.effectiveDate = ratePeriodRec.effectiveDate;
                    rateFileRecords.expiryDate = ratePeriodRec.expiryDate;
                    rateFileRecords.controlId = ratePeriodRec.controlId;
                    this.tmssLoader.hide();
                }, (error) => {
                    this.alertService.error('Rate Period Record did not get populated');
                    this.tmssLoader.hide();
                });
            });
        if (this.rateFileTspExtForm.controls['rateType'].value === 'HHG Rate Filing') {
            this.businessType = 'HHG';
        }
        if (this.rateFileTspExtForm.controls['rateType'].value === 'FRT Rate Filing') {
            this.businessType = 'FRT';
        }

        this.getcarrierList(this.businessType);
    }
    /*
    * Get all the carriers based on the Business Type for the Type head
    */

    getcarrierList(businessType: any) {
        console.log('Business Type ', this.businessType);
        this.tmssLoader.show();
        this.rateFileTspExtService.getCarrierList(this.businessType)
            .subscribe(carrierRecords => {
                this.carrierList = carrierRecords;
                console.log(this.carrierList);
                for (const carrierOutput of carrierRecords) {
                    this.scacCodeList.push(carrierOutput.scac);
                    this.tmssLoader.hide();
                }
            });
    }
    /*
    * When the user selects the rate period from the drop down the carrier key word field setting is made
    */

    changeRatePerid(event: any) {
        console.log(this.rateFileTspExtForm.controls['ratePeriod'].value);
        this.tmssLoader.show();
        this.disabled = false;
        this.minLengthToSearch = 1;
        this.maxCharLength = 4;
        this.typeaheadlist = this.scacCodeList;
        this.tmssLoader.hide();
    }
    /*
    * When the user clicks the getDetails button
    */

    getCarrierDetails() {
        console.log(this.rateFileTspExtForm.controls['carrierKeyword'].value);
        console.log(this.rateFileTspExtForm.controls['ratePeriod'].value);
        this.tmssLoader.show();
        this.selectedCarrier = this.carrierList.filter(x => x.scac === (this.rateFileTspExtForm.controls['carrierKeyword'].value));
        console.log(this.selectedCarrier.length);
        if (this.selectedCarrier.length !== 0) {
            console.log(this.selectedCarrier[0].carrierId);
            this.rateFileTspExtService.getCarrierRateRec(this.rateFileTspExtForm.controls['ratePeriod'].value,
                this.selectedCarrier[0].carrierId)
                .subscribe(carrierRateRecords => {
                    this.carrierRateRec = carrierRateRecords;
                    console.log(this.carrierRateRec);
                    console.log(carrierRateRecords);
                    if (carrierRateRecords.scac === null) {
                        this.rateFileTspExtService.getRatePeriodRec(this.rateFileTspExtForm.controls['ratePeriod'].value)
                            .subscribe(ratePeriodRecord => {
                                this.ratePeriodRec = ratePeriodRecord;
                                this.rateFileTspExtForm.controls['rateEffeciveDate'].setValue(ratePeriodRecord.effectiveDate);
                                this.rateFileTspExtForm.controls['rateExpiryDate'].setValue(ratePeriodRecord.expiryDate);
                                this.rateFileTspExtForm.controls['rateReleaseDate'].setValue(ratePeriodRecord.releaseDate);
                                this.currentRatePeriod =  this.ratePeriodDetails[0].controlId;
                                console.log(this.currentRatePeriod);
                                console.log(this.rateFileTspExtForm.controls['ratePeriod'].value);
                                if (parseInt(this.currentRatePeriod) === parseInt(this.rateFileTspExtForm.controls['ratePeriod'].value)) {
                                    console.log('button disable false');
                                    this.buttonDisable = false;
                                } else {
                                    console.log('button disable true');
                                    this.buttonDisable = true;
                                }
                            }, error => {
                                this.tmssLoader.hide();
                            });
                        this.rateFileTspExtForm.controls['carrierSelected'].setValue(this.selectedCarrier[0].scac + ' - ' + this.selectedCarrier[0].scacName);
                        this.rateFileTspExtForm.controls['tspExpiryDate'].setValue('');
                        this.rateFileTspExtForm.controls['carrierSelectedForTable'].setValue('');
                        this.rateFileTspExtForm.controls['rateEffeciveDateForTable'].setValue('');
                        this.rateFileTspExtForm.controls['rateExpiryDateForTable'].setValue('');
                    } else {
                        this.rateFileTspExtForm.controls['carrierSelectedForTable'].setValue(carrierRateRecords.scac + ' - ' + carrierRateRecords.scacName);
                        this.rateFileTspExtForm.controls['rateEffeciveDateForTable'].setValue(carrierRateRecords.rateEffectiveDate);
                        this.rateFileTspExtForm.controls['rateExpiryDateForTable'].setValue(carrierRateRecords.expiryDate);
                        this.rateFileTspExtForm.controls['rateEffeciveDate'].setValue('');
                        this.rateFileTspExtForm.controls['carrierSelected'].setValue('');
                        this.rateFileTspExtForm.controls['tspExpiryDate'].setValue('');
                        this.rateFileTspExtForm.controls['rateExpiryDate'].setValue('');
                        this.rateFileTspExtForm.controls['rateReleaseDate'].setValue('');
                    }
                    this.tmssLoader.hide();
                });
        } else {
            this.alertService.error('The SCAC selected does not exist');
            this.tmssLoader.hide();
        }
    }
    /*
    * When the user clicks the Save button
    */

    saveTSPExpirtyDate() {
        console.log('Expiry Date ', this.rateFileTspExtForm.controls['rateExpiryDate'].value);
        console.log('Effective Date', this.rateFileTspExtForm.controls['rateEffeciveDate'].value);
        console.log('Release Date ', this.rateFileTspExtForm.controls['rateReleaseDate'].value );
        let expiryDate = null;
        if (this.rateFileTspExtForm.controls['rateExpiryDate'].value !== null) {
            expiryDate = new Date(this.rateFileTspExtForm.controls['rateExpiryDate'].value);
        }
        let tspEnteredDate = null;
        if (this.rateFileTspExtForm.controls['tspExpiryDate'].value !== null) {
            tspEnteredDate = new Date(this.rateFileTspExtForm.controls['tspExpiryDate'].value);
        }
        let releaseDate = null;
        if (this.rateFileTspExtForm.controls['rateReleaseDate'].value !== null) {
            releaseDate = new Date(this.rateFileTspExtForm.controls['rateReleaseDate'].value);
        }
        if ( tspEnteredDate !== null && expiryDate !== null && tspEnteredDate < expiryDate ) {
            this.alertService.error('TSP Expirty Date can\'t be less than Rate Expirty Date');
        } else
        if (tspEnteredDate !== null && releaseDate !== null && tspEnteredDate > releaseDate ) {
            this.alertService.error('You can\'t update TSP Rate extension for rates already released');
        }
        this.ratesTspExt = new RatesTspExt();

        this.ratesTspExt.controlId = this.rateFileTspExtForm.controls['ratePeriod'].value;
        this.ratesTspExt.carrierId = this.selectedCarrier[0].carrierId;
        this.ratesTspExt.rateEffectiveDate = this.rateFileTspExtForm.controls['rateEffeciveDate'].value;
        this.ratesTspExt.expiryDate = this.rateFileTspExtForm.controls['tspExpiryDate'].value;
        this.ratesTspExt.scac = this.selectedCarrier[0].scac;
        this.ratesTspExt.scacName = this.selectedCarrier[0].scacName;
        this.ratesTspExt.updateDate = 0;
        this.ratesTspExt.updateId = 0;
        this.ratesTspExt.updateProgram = '';

        console.log('Record to be update ', this.ratesTspExt);
        this.tmssLoader.show();
        this.updateSuccessful = false;
        this.updateFailure = false;
        this.rateFileTspExtService.createRatesTspExt(this.ratesTspExt)
            .subscribe ( data => {
                if (data.ratesTspId !== 0) {
                    console.log('Created TSP Record ', data);
                    this.updateFailure = false;
                    this.updateSuccessful = true;
                    this.rateFileTspExtForm.controls['carrierSelectedForTable'].setValue(this.ratesTspExt.scac + ' - ' + this.ratesTspExt.scacName);
                    this.rateFileTspExtForm.controls['rateEffeciveDateForTable'].setValue(this.ratesTspExt.rateEffectiveDate);
                    this.rateFileTspExtForm.controls['rateExpiryDateForTable'].setValue(this.ratesTspExt.expiryDate);
                    this.rateFileTspExtForm.controls['rateEffeciveDate'].setValue('');
                    this.rateFileTspExtForm.controls['carrierSelected'].setValue('');
                    this.rateFileTspExtForm.controls['tspExpiryDate'].setValue('');
                    this.rateFileTspExtForm.controls['rateExpiryDate'].setValue('');
                    this.tmssLoader.hide();
                } else {
                    this.alertService.error('The record creation failed');
                    this.updateFailure = true;
                    this.updateSuccessful = false;
                    this.tmssLoader.hide();
                }
            }, error => {
                console.log('Error in creating the record', error);
                this.updateFailure = true;
                this.updateSuccessful = false;
                this.tmssLoader.hide();
            });

    }
}

